/* eslint-disable react/prop-types */
import classes from "./card-view-admin-announcement.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import classNames from "classnames";
import * as announcementHelper from "@/common/announcement-helper";
import Image from "@/components-library/widgets/image";
import TextTruncate from "@/components-library/widgets/text-truncate/text-truncate";
function CardViewAnnouncement({
  title,
  promoting,
  isPreview,
  outgoings,
  image,
  date,
  status,
  onAnnouncementSelect,
  onAnnouncementPreview,
  dateLabel,
  admin,
}) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="space-between"
      className={classes.container}
    >
      <Flex
        align="flex-start"
        direction="column"
        justify="center"
        className={classes.info}
      >
        <Image
          src={image}
          alt="Logo"
          className={classes.image}
          placeholder={announcementHelper.PLACEHOLDER}
        />

        <Flex
          align="flex-start"
          direction="column"
          justify="center"
          className={classes.content}
        >
          <TextTruncate
            line={3}
            element={"h6"}
            truncateText="…"
            text={title}
            containerClassName={classes.title}
            maxCalculateTimes={100}
          />

          <TextTruncate
            line={4}
            element={"p"}
            truncateText="…"
            text={`Ente promotore: ${promoting}`}
            containerClassName={classes.title}
            maxCalculateTimes={100}
          />

          <Label
            weight="bold"
            align="start"
            size="sm"
            color="secondary"
            className={classes.date}
          >
            {`${dateLabel} ${date}`}
          </Label>
          <Label
            weight="bold"
            align="start"
            size="sm"
            color="secondary"
            className={classes.date}
          >
            {`Spese finanziate ${announcementHelper.listToString(outgoings)}`}
          </Label>
        </Flex>
      </Flex>
      <Flex align="flex-start" direction="row" justify="center">
        <Button
          onClick={onAnnouncementSelect}
          size="sm"
          color="primary"
          className={classes.button}
        >
          {admin ? "MODIFICA" : "ENTRA"}
        </Button>
        {admin && (
          <Button
            onClick={onAnnouncementPreview}
            size="sm"
            color="primary"
            className={classes.button}
          >
            PREVIEW
          </Button>
        )}
      </Flex>

      <Flex
        align="flex-start"
        direction="row"
        justify="center"
        className={classes.statuses}
      >
        <Label
          weight="bold"
          align="start"
          size="md"
          color="secondary"
          className={classNames(classes.status, {
            [classes.closed]: status === announcementHelper.Status.CLOSED,
            [classes.opened]: status === announcementHelper.Status.OPEN,
            [classes.reporting]: status === announcementHelper.Status.REPORTING,
            [classes.activating]:
              status === announcementHelper.Status.ACTIVATING,
          })}
        >
          {status}
        </Label>

        {isPreview && admin && (
          <Label
            weight="bold"
            align="start"
            size="md"
            color="secondary"
            className={classNames(classes.preview)}
          >
            PREVIEW
          </Label>
        )}
      </Flex>
    </Flex>
  );
}

export default CardViewAnnouncement;
